<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
    <div class="card">
        <div class="card-body">
            <form class="text-dark" [formGroup]="dcaInformation">
                <div class="form-row">
                    <div class="form-group col-lg col-sm-12">
                        <label for="costPercentOfFee">Cost Percent Of Fee</label>
                        <td><percent-input [id]="'costPercentOfFee'" [control]="dcaInformation.get('costPercentOfFee')"></percent-input></td>
                    </div>
                    <div class="form-group col-lg col-sm-12">
                        <label for="feeCapPercentage">Fee Cap Percentage</label>
                        <td><percent-input [id]="'feeCapPercentage'" [control]="dcaInformation.get('feeCapPercentage')"></percent-input></td>
                    </div>
                </div>
            </form>

            <h4>Fee Caps based on Coverage Term Range</h4>
            <p class="subtitle"> Rates can be obtained from the DCA company.</p>

            <form [formGroup]="dcaInformation">
                <ng-container formArrayName="terms">
                    <table class="table table-hover table-sm">
                        <thead>
                            <tr>
                                <th>Term Months From</th>
                                <th>Term Months To</th>
                                <th>Max Fee (in dollars)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (rangeForm of terms.controls; track rangeForm; let i = $index) {
                                <tr>
                                    <td><count-input [id]="'termMonthsFrom' + i" [control]="rangeForm.get('termMonthsFrom')"></count-input></td>
                                    <td><count-input [id]="'termMonthsTo' + i" [control]="rangeForm.get('termMonthsTo')"></count-input></td>
                                    <td><currency-input [id]="'dollarCap' + i" [control]="rangeForm.get('dollarCap')"></currency-input></td>
                                    <td class="actions"><button class="btn btn-link" (click)="discardTerms(i)"><span class="dripicons-trash text-danger"></span></button></td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </ng-container>
            </form>

            <div class="card-footer">
                <button class="btn btn-sm btn-success" (click)="addTerms()"><span class="uil-plus"></span></button>
                <button class="btn btn-sm btn-primary" (click)="saveDCA()" [disabled]="!dcaInformation.valid || contactId == 0">Save</button>
            </div>
        </div>
    </div>
    @if (calledFrom == null) {
    <div class="text-right">
        <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
        @if (calledFrom !== null) {
        <button class="btn btn-sm btn-primary">Cancel &amp; Close</button>
        }
    </div>
    }
</div>
